export default class MenuItem {

    constructor(name, route, icon = '', children = [], useVueRouter = true) {
        this.name = name;
        this.route = route;
        this.icon = icon;
        this.children = children;
        this.useVueRouter = useVueRouter;
    }

}
